import { sourceRegex } from '@ms-cloudpack/path-utilities';

/**
 * When we derive keys, we want to preserve unknown script extensions. For others, remove them as the bundler
 * will add back `'.js'` for us in the output.
 */
export function toNormalizedEntryKey(entry: string): string {
  return entry.replace(sourceRegex, '');
}
